'use client';

import { useState } from 'react';
import { sendGAEvent } from '@next/third-parties/google';
import styles from './ArticleDetail.module.css';

export default function FinanceWidget() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleSpecs = () => {
        const newState = !isOpen;
        setIsOpen(newState);

        if (newState) {
            sendGAEvent('event', 'select_content', {
                content_type: 'accordion',
                item_id: 'specs_accordion'
            });
        }
    };

    const handleAction = (action: string) => {
        sendGAEvent('event', 'select_content', {
            content_type: 'finance_button',
            item_id: action
        });
        // Logic for finance/insurance would go here (e.g. open modal)
        alert(`Feature coming soon: ${action}`);
    };

    return (
        <div className={styles.card} style={{ borderColor: 'var(--color-primary)' }}>
            <div className={styles.cardTitle} style={{ color: 'var(--color-primary)' }}>Buying This Car?</div>

            <div style={{ marginBottom: '16px' }}>
                <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--text-primary)' }}>2024 VW Golf 8 R</div>
                <div style={{ fontSize: '24px', fontWeight: 'bold', color: 'var(--text-primary)', marginTop: '4px' }}>R 950,000</div>
                <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>Estimated Price</div>
            </div>

            <button onClick={() => handleAction('finance')} className="btn btn-primary" style={{ width: '100%', marginBottom: '8px' }}>
                Check Finance
            </button>
            <button onClick={() => handleAction('insurance')} className="btn btn-outline" style={{ width: '100%' }}>
                Insurance Quote
            </button>

            {/* Accordion Section */}
            <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid var(--border-subtle)' }}>
                <button
                    onClick={toggleSpecs}
                    className="flex justify-between items-center w-full text-left"
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                >
                    <span style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)' }}>
                        Performance Specs
                    </span>
                    <span style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                        ▼
                    </span>
                </button>

                {isOpen && (
                    <div className="animate-fade-in" style={{ marginTop: '12px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '8px' }}>
                            <span style={{ color: 'var(--text-muted)' }}>Power</span>
                            <span style={{ fontWeight: 600 }}>235 kW</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '8px' }}>
                            <span style={{ color: 'var(--text-muted)' }}>Torque</span>
                            <span style={{ fontWeight: 600 }}>400 Nm</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                            <span style={{ color: 'var(--text-muted)' }}>0-100 km/h</span>
                            <span style={{ fontWeight: 600 }}>4.8s</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
